import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { existsModule } from "features/shared/helpers/modules";
import React from "react";
import DynamicSvgIcon from "./DynamicSvgIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  icon: IconProp;
  size?: SizeProp;
  fixedWidth?: boolean;
}

const Icon = ({ icon, size, fixedWidth }: Props) => {
  // helpers
  const getSizeClass = () => {
    if (size) {
      return ` fa-${size}`;
    }

    return "";
  };

  const getFixedWidthClass = () => {
    if (fixedWidth) {
      return " fa-fw";
    }

    return "";
  };

  const getCssClasses = () => {
    let basicClass = "svg-inline--fa";
    return `${basicClass}${getSizeClass()}${getFixedWidthClass()}`;
  };

  // render
  if (existsModule(`icons/${icon}.svg`)) {
    return <DynamicSvgIcon name={`${icon}`} className={getCssClasses()} />;
  } else {
    return <FontAwesomeIcon icon={icon} size={size} fixedWidth={fixedWidth} />;
  }
};

export default Icon;
